import React from 'react';
import { Helmet as Head } from 'react-helmet';

import { string } from 'prop-types';

const Helmet = ({ title }) => {
  const gaCode = import.meta.env.VITE_GA_TRACKING_CODE || '';

  return (
    <Head titleTemplate="Aliant | %s">

      <script async src={ `https://www.googletagmanager.com/gtag/js?id=${gaCode}` } />
      <script>
        {
          `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaCode}');`
        }
      </script>

      <meta charSet="utf-8" />

      <title>{title}</title>

      <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;600;700&display=swap" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500;700&display=swap" rel="stylesheet" />
    </Head>
  );
};

Helmet.propTypes = {
  title: string.isRequired,
};

export default Helmet;
